<template>
  <form onsubmit="return false" @submit="SET_NOTE({
    nota: note,
    tipo_nota: tipo_nota,
    id: job.id,
    criado_por: user.id,
    nome_criado_por: user.nome,
  });
  modal.show = false;" class="note column label wrap">
    <div class="row wrap">
      <div class="grid-6-s grid-3 grid-12-s">
        Cliente
        <br />
        <strong>{{ job.nome_cliente }}</strong>
      </div>
      <div class="grid-6-s grid-5 grid-12-s">
        Supporter
        <br />
        <strong>{{ job.nome_doutor }}</strong>
      </div>
      <div class="grid-6-s grid-4 grid-12-s">
        Gestor de Demanda
        <br />
        <strong>{{ job.status.replace("Doutor", "Supporter") }}</strong>
      </div>
    </div>
    <div class="grid-12">
      Problema
      <br />
      <strong v-html="job.problema.replace(/\n/g, '<br />')"></strong>
    </div>
    <div class="column mt">
      <br />
      <br />
      <div v-if="user.perfil == 'funcionario'">
        Tipo
        <select class="input" v-model="tipo_nota" required>
          <option value="">Selecione</option>
          <option value="anotacao">Anotação</option>
          <option value="complemento_escopo">Complemento de Escopo</option>
          <option value="interna">Interna</option>
        </select>
      </div>
      <div class="grid-12" style="margin-top: 10px">
        <br />Anotação<br />
        <textarea class="textarea grid-11" v-model="note" required></textarea>
      </div>
    </div>
    <div class="row grid-12 justify-center">
      <div class="grid-4-g justify-center row">
        <Button layout="green-go">INSERIR ANOTAÇÃO</Button>
      </div>
    </div>
  </form>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.note {
  padding: 10px 30px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: $gray-6;
  font-size: 15px;

  @media (min-width: $small) {
    /* width: 50%; */
    width: 600px;
  }

  button {
    margin-top: 55px;
  }

  strong {
    font-weight: 500;
    color: $gray-1;
  }

  .grid-12-s {
    margin-bottom: 12px;
  }
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
export default {
  name: "Orientation",
  props: {
    modal: Object,
  },
  components: {
    Button,
  },
  data() {
    return {
      job: this.GET_JOB(),
      loader: true,
      note: "",
      tipo_nota: ''
    };
  },
  methods: {
    ...mapActions("job", ["SET_NOTE"]),
    ...mapGetters("job", ["GET_JOB"]),
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>
